export class InsertNotificationDTO {
  title: string = '';
  body: string = '';
  topic: string = '';
}
